import { useSelector } from "react-redux"

export const useRoutes = () => {

    const isLoggedIn = useSelector(state => state.userData.userData)
    
    return {
        isLoggedIn,
    }
}